export class LoginBannerEndpoints {
	/**
	 * Fetches the login banner content.
	 */
	public static readonly GET = 'loginbanner';
}